"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactNativeWeb = require("react-native-web");

var isAndroid = _reactNativeWeb.Platform.OS === 'android'; // Dynamic require it's not supported in metro.

var Images = {
  islandTransfer: isAndroid ? 'ic_islandtransfer.png' : require("./ic_islandtransfer.png"),
  swapIcon: isAndroid ? 'ic_switch.png' : require("./ic_switch.png"),
  closeIcon: isAndroid ? 'ic_close.png' : require("./ic_close.png"),
  checkIcon: isAndroid ? 'ic_check.png' : require("./ic_check.png"),
  arrowLeftIcon: isAndroid ? 'ic_arrow_left.png' : require("./ic_arrow_left.png"),
  arrowRightIcon: isAndroid ? 'ic_arrow_right.png' : require("./ic_arrow_right.png"),
  arrowRightIconWhite: isAndroid ? 'ic_arrow_right_white.png' : require("./ic_arrow_right_white.png"),
  arrowDropdown: isAndroid ? 'ic_drop_down_up.png' : require("./ic_drop_down_up.png"),
  recentSearches: isAndroid ? 'ic_recent_1.png' : require("./ic_recent_1.png"),
  nearestAirport: isAndroid ? 'ic_location.png' : require("./ic_location.png"),
  flightIcon: isAndroid ? 'ic_flight.png' : require("./ic_flight.png"),
  flightIconBlue: isAndroid ? 'ic_flight_blue.png' : require("./ic_flight_blue.png"),
  cityTransfer: isAndroid ? 'ic_citytransfer.png' : require("./ic_citytransfer.png"),
  otherAirlines: isAndroid ? 'ic_exlink_blue.png' : require("./ic_exlink_blue.png"),
  location: isAndroid ? 'ic_location.png' : require("./ic_location.png"),
  calendar: isAndroid ? 'ic_calendar.png' : require("./ic_calendar.png"),
  warningIcon: isAndroid ? 'ic_warning.png' : require("./ic_warning.png"),
  airportIcon: isAndroid ? 'ic_airport.png' : require("./ic_airport.png"),
  poiIcon: isAndroid ? 'ic_poi.png' : require("./ic_poi.png"),
  navBackWhiteIcon: isAndroid ? 'ic_nav_back_white.png' : require("./ic_nav_back_white.png"),
  noResultsIcon: isAndroid ? 'ic_no_results.png' : require("./ic_no_results.png"),
  expandMore: isAndroid ? 'ic_expand_more.png' : require("./ic_expand_more.png")
};
var _default = Images;
exports["default"] = _default;